import { REQUEST_STATUS_CHANGE } from './constants'

export const statusChanged = (status, message) => {
  return {
    type: REQUEST_STATUS_CHANGE,
    status,
    message
  }
}



// WEBPACK FOOTER //
// ./src/components/RequestStatus/actions.js